import { createBrowserHistory } from 'history';

let history = createBrowserHistory();

history.listen(location => {
  if ('noScroll' in (location.state ?? {})) return;
  setTimeout(() => {
    if (location.hash) {
      let ele = window.document.querySelector(location.hash);
      if (ele) {
        ele.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, 1);
});

export default history;
